<template>
  <div class="loading">
    <img src="@/assets/images/spinner.gif" :width="size" :height="size" />
    <h3>Loading...</h3>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    size: String
  }
};
</script>

<style lang="scss" scoped>
.loading {
  h4 {
    margin-top: 20px;
  }
}
</style>
